import React, {ReactElement} from "react";
import classes from './Rozvrh.module.scss'
import rozvrhscreenshot from "../../images/rozvrhscreenshot.png";


const Rozvrh = (): ReactElement => {
	return (
		<>
			<div className={classes.container}>
				<div className={classes.image}>
					<img alt='Screenshot aplikace' src={rozvrhscreenshot}/>
				</div>
				<div className={classes.text}>
					<h3>Historie a motivace</h3>
					<p>
						Jeden z mých prvních projektů (první veřejně vydaný), který jsem začal vyvíjet někdy v polovině
						šesté třídy na základní škole v Javě jako projekt, na kterém jsem se chtěl naučit základní (i
						pokročilé) koncepty objektově orientovaného programování. Tuto aplikaci jsem začal vyvíjet,
						protože jsem nikde na internetu nenašel jinou aplikaci pro rozvrh a evidenci úkolů a testů v
						jedné ucelené aplikaci.
					</p>
					<h3>Funkce</h3>
					<p>
						Do aplikace bylo možné zadat jednotýdenní rozvrh od nulté do osmé hodiny (nultá a osmá hodina
						byla zapinatelná, ve výchozím stavu vypnutá)
						Délku hodin a začátek každé hodiny se dalo nastavit v jednoduchém a uživatelsky přívetivém
						nastavení.
						Dále bylo možné nastavit jednotlivé předměty, které byly na každé škole jinak pojmenované, navíc
						se ke každému předmětu dala nastavit zkratka předmětu a bylo na výběr přes 20 ikonek k předmětu.
						Hlavní funkce aplikace byla evidence domácích úkolů a testů přiřazené k předmětu z rozvrhu. K
						testu či úkolu se dal přidat termín, který automaticky aplikace počítala podle aktuálního dne a
						výskytu hodiny v rozvrhu. Na základě této informace také aplikace zjišťovala kolik testů a úkolu
						je nedokončených do následujíco dne a ukázala den předem informaci o počtu testů a úkolů.
						Rozvrh taky chytře ukazoval notifikaci těsně před hodinou, která obsahovala informaci o tom jaká
						hodina je a kolik testů a úkolů je k tomuto termínu.
						Celý notifikační sytém byl nastavitelný přes hezké a jednoduché nastavení.
					</p>
					<h3>Konec aplikace</h3>
					<p>
						Asi po roce úspěšném fungování na obchodu play jsem se na základě uživatelských recenzí rozhodl
						aplikaci rozšířit o online synchronizaci do cloudu a sdílených dat mezi třídou. Do rozvrhu jsem
						přidal přihlašovací systém a celou novou sekci se sdílením obsahu. Rozvrh se dal jednoduše
						sdílet pomocí QR kódu, který si druhý uživatel naskenoval a sám se spustil proces synchronizace.
						Všechno vypadalo slibně, uživatelům se tato funkce líbila a využívalo ji čím dál tím víc lidí.
						Ještě ten rok ovšem evropská unie vydala nařízení o zpracování osobních údajů (GDPR) a to
						aplikaci ublížilo.
						Dostal jsem několik upozornění, že aplikace bude smazána z obchodu pokud nedodám potřebé
						dokumenty o zpracování údajů a jak s nimi nakládám.
						V té době jsem ovšem neměl žádné zkušenosti z psaním dokumentů a nechápal jsem jak tyto
						dokumenty napsat a jak celé GDPR funguje. Asi půl roku po prvním mailu mi aplikaci smazali z
						obchodu play a to byl definitivní konec. Rozhodl jsem se, že aplikaci již nadále nebudu vyvíjet.
					</p>
				</div>
			</div>
		</>
	)
}

export default Rozvrh